import { getSubscriptionById } from '@vista/omnichannel-components-domain';
export const getMemberSubscriptionName = (i18n, memberSubscription) => {
    if (!memberSubscription)
        return undefined;
    const { subscriptionId } = memberSubscription;
    const subscription = getSubscriptionById(subscriptionId);
    if (!subscription)
        return;
    return i18n.translatable(subscription.name);
};
